import React from 'react';
import { FormattedMessage } from 'react-intl';
import SupportIcon from 'resources/svg/contact-support.svg';
import styles from './ContactSupport.module.scss';

export default function ContactSupport({ supportUrl }) {
  return (
    <div className={styles.container} data-testid="login-form-contact-support">
      <div className={styles.icon}>
        <SupportIcon />
      </div>
      <div>
        <FormattedMessage id="LOG_IN_NEED_HELP" />
        <br />
        <FormattedMessage
          id="LOG_IN_CONTACT_CUSTOMER_SUPPORT"
          values={{
            // eslint-disable-next-line react/display-name
            a: chunks => (
              <a href={supportUrl} target="_blank" rel="noreferrer">
                {chunks}
              </a>
            ),
          }}
        />
      </div>
    </div>
  );
}
